import {
    REQUEST_REGULAR_INVOICES,
    RECEIVE_REGULAR_INVOICES,
    UPDATE_REGULAR_INVOICES,
    ERROR_REGULAR_INVOICES
} from '../types'
import {fetchUrl} from '../../constants/constants'
import {requestItem, receiveItem, failedItem} from "../actions"
import fetchErrorCtrl from "../../helpers/fetchErrorCtrl"
import shouldFetch from "../../helpers/shouldFetch"
import axios from 'axios'
import prepareFilters from "../../helpers/prepareFilters";

function request() {
    return {
        type: REQUEST_REGULAR_INVOICES
    };
}

export function receive(data) {
    return {
        type: RECEIVE_REGULAR_INVOICES,
        payload: data
    }
}

function failed(data) {
    return {
        type: ERROR_REGULAR_INVOICES,
        errors: data
    }
}

function update(data, id, updateType) {
    return {
        type: UPDATE_REGULAR_INVOICES,
        id,
        payload: data,
        updateType
    }
}

export function getRegularInvoices(params = {}, force = false) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().regularInvoices, !force)) {
            dispatch(request())
            return axios({
                method: 'GET',
                url: fetchUrl + 'regular-invoices',
                params: prepareFilters(params, getState(), "regularInvoices")
            }).then(res => {
                dispatch(receive(res.data.data))
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failed(errors))
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function getRegularInvoice(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('regularInvoice'))
            return axios({
                method: 'GET',
                url: fetchUrl + 'regular-invoices/' + id
            }).then(res => {
                dispatch(receiveItem(res.data.data))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function createRegularInvoice(data) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem())
            return axios({
                method: 'POST',
                url: fetchUrl + 'regular-invoices',
                data
            }).then(res => {
                dispatch(receiveItem({}, 'message.item_created'))
                dispatch(update(res.data.data, false, 'create'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function updateRegularInvoice(data, id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('regularInvoice'))
            return axios({
                method: 'PUT',
                url: fetchUrl + 'regular-invoices/' + id,
                data
            }).then(res => {
                dispatch(receiveItem(res.data.data, 'message.item_updated'))
                dispatch(update(res.data.data, id, 'update'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function deleteRegularInvoice(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem())
            return axios({
                method: 'DELETE',
                url: fetchUrl + 'regular-invoices/' + id
            }).then(res => {
                dispatch(receiveItem({}, 'message.item_deleted'))
                dispatch(update(res.data.data, id, 'delete'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}